import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async getItems ({ commit, dispatch }) {
    try {
      const { data } = await directus.getUsers({
        fields: [
          'id',
          'first_name',
          'last_name',
          'email',
          'avatar.data',
        ]
      })
      commit('setAttr', {
        name: 'models',
        value: data
      })
    } catch (err) {
      errorDirectus(err, dispatch)
    }
  }
}
